/**
 * Layout racine de l'application
 */

import { Outlet } from 'react-router-dom';
import { Toaster } from 'react-hot-toast';
import { ConfirmDialog } from '../../shared/components/ConfirmDialog/ConfirmDialog';

export function RootLayout() {
  return (
    <div className="min-h-screen bg-surface-raised">
      <Outlet />
      <ConfirmDialog />
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 5000,
          style: {
            background: '#363636',
            color: '#fff',
          },
        }}
      />
    </div>
  );
}

export default RootLayout;
